// Venue Canvas, full screen (__root.tsx renders 'venue-canvas' without the sidebar or top bar, like the
// Studio). The venue module's editor: src/modules/venue-port.
import React from 'react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { VenueCanvasRoute } from '../modules/venue-port/tkt/VenueRoutes';
import { venueNav } from '../modules/venue-port/tkt/venueNav';

const str = (v: unknown) => (typeof v === 'string' && v ? v : undefined);
type CanvasSearch = { level?: string; plan?: string; event?: string; preview?: string; focus?: string; row?: string; unit?: string;
  tool?: string; ba?: Record<string, unknown>; replay?: string; from?: 'event' };

export const Route = createFileRoute('/venues/$id/canvas')({
  validateSearch: (s: Record<string, unknown>): CanvasSearch => ({
    level: str(s.level), plan: str(s.plan), event: str(s.event), preview: s.preview === '1' || s.preview === 1 ? '1' : undefined,
    focus: str(s.focus), row: str(s.row), unit: str(s.unit),
    // The links the Studio took (the event page's Seating tab): ?tool= opens Best Available, the fill order or
    // History; ?ba= a Best Available question; ?replay= a simulated sale (still the Studio's); ?from=event
    // makes the back arrow return to the event.
    tool: ['ba', 'fill', 'history'].includes(s.tool as string) ? (s.tool as string) : undefined,
    ba: s.ba && typeof s.ba === 'object' ? (s.ba as Record<string, unknown>) : undefined,
    replay: str(s.replay), from: s.from === 'event' ? 'event' : undefined,
  }),
  component: function VenueCanvas() {
    const { id } = Route.useParams();
    const search = Route.useSearch();
    const nav = venueNav(useNavigate(), '/venues/$id/canvas', { id });
    return <VenueCanvasRoute venueId={id} search={search} nav={nav} />;
  },
});
